import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "@/lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("auc-lang") || "de");

  useEffect(() => {
    localStorage.setItem("auc-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = TRANSLATIONS[lang];
  const toggle = () => setLang((l) => (l === "de" ? "en" : "de"));
  const tr = (obj) => (obj && typeof obj === "object" ? obj[lang] : obj);

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t, tr }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
